import React from 'react'
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { redirectTo } from 'src/utils/Http';
import { optionStyles, locale } from '../customize';
import { checkCreatePath, checkDashboardsPath, checkShowListPath } from './target/create'

export default function createSalaryRuleStep({ cookie, setTutorialStep2 }) {
    const { run, stepIndex, tourCompleted, type } = cookie
    const { t } = useTranslation()

    const step = [
        {
            target: checkDashboardsPath('#payroll_rules_groups.Setup__item--1ANJP'),
            content: t('features.GuideTour.PayrollRulesGroups.CreateStep.0'),
            disableBeacon: true,
            placement: 'auto',
        },
        {
            target: checkShowListPath('.PayrollRulesGroupsList__buttons--1PLSi .PayrollRulesGroupsList__create--3AAwq'),
            content: t('features.GuideTour.PayrollRulesGroups.CreateStep.1'),
            placement: 'auto',
        },
        {
            target: checkCreatePath('.Form__boxMain--1CHRX'),
            content: t('features.GuideTour.PayrollRulesGroups.CreateStep.2'),
            placement: 'auto',
        },
        {
            target: checkCreatePath('.Form__boxWrap--3FgDf:nth-child(6)'),
            content: (
                <React.Fragment>
                    {t('features.GuideTour.PayrollRulesGroups.CreateStep.3').split(';').map((text, index) =>
                        <p key={index} style={{ textAlign: 'left' }}>{text}</p>
                    )}
                </React.Fragment>
            ),
            placement: 'auto',
        }
    ];

    const setStepIndex = (newIndex) => {
        setTutorialStep2({ run, stepIndex: newIndex, tourCompleted, type })
    }
    const setTourCompleted = () => {
        setTutorialStep2({ run: false, stepIndex: 0, tourCompleted: false, type: '' })
    }
    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        const newIndex = index + (action === 'prev' ? -1 : 1);

        if (action === 'skip') {
            setTourCompleted()
        }
        else if (type === 'step:after' && index === 0) {
            setStepIndex(newIndex)
            redirectTo('/clients/payroll_rules_groups')
        }
        else if (type === 'step:after' && index === 1) {
            setStepIndex(newIndex)
            action === 'next' ? redirectTo('/clients/payroll_rules_groups/new') : redirectTo('/dashboards')
        }
        else if (type === 'step:after' && index === 2) {
            setStepIndex(newIndex)
            action === 'prev' && redirectTo('/clients/payroll_rules_groups')
        }
        else if (type === 'step:after' && index === 3) {
            action === 'prev' && setStepIndex(newIndex)
            // setStepIndex(newIndex)
        }
    };

    return (
        <Joyride
            steps={step}
            run={run}
            stepIndex={stepIndex}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            scrollToFirstStep
            hideCloseButton
            showProgress
            showSkipButton
            disableOverlayClose
        />
    )
}
